import(/* webpackMode: "eager", webpackExports: ["RootLayoutNew"] */ "/home/runner/work/sapling/sapling/packages/foundation/src/components/RootLayout-new-v3.tsx");
